import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ToggleSwitch from '../../../components/UI/ToggleSwitch';
import WidgetPropTypes from '../types';
import css from './AutofundingToggle.module.scss';

export const WIDGET_NAME = 'set_autofunding_preference';
const AUTOFUNDING_PREFERENCE_DESCRIPTION =
  'Add $20 automatically when funds are below $10';
const AUTOFUNDING_PREFERENCE_HEADER =
  'Make sure you always have money available to send your child:';

const AutofundingToggle = ({ changeAnswerValue, widget, app, segment }) => {
  const [autofundingPreferred, setAutofundingPreferred] = useState(
    app.autofundingPreferred
  );

  // Set constants for the Autofunding toggle experiment:
  const amount = 20;
  const triggerAmount = 10;
  const walletId = app.walletId || get(app, 'registeredUser.user.walletId');

  useEffect(() => {
    segment.page('Registration', 'Autofunding Preference Toggle Viewed');
  }, []);

  useEffect(() => {
    changeAnswerValue(widget, {
      wallet_autofunding_enabled: autofundingPreferred,
      wallet_id: walletId,
      amount,
      trigger_amount: triggerAmount,
      type: 'trigger'
    });
  }, [autofundingPreferred]);

  const handleChange = () => setAutofundingPreferred(!autofundingPreferred);

  return (
    <div className={css.widgetContainer}>
      <p className={css.widgetHeadline}>{AUTOFUNDING_PREFERENCE_HEADER}</p>
      <div className={css.toggleContainer}>
        <ToggleSwitch
          onChange={handleChange}
          checked={autofundingPreferred}
          toggleName="autofunding"
        />
        <p className={css.toggleDescription}>
          {AUTOFUNDING_PREFERENCE_DESCRIPTION}
        </p>
      </div>
    </div>
  );
};

AutofundingToggle.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  widget: WidgetPropTypes.widget.isRequired
};

export default AutofundingToggle;
